import React, { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import "../Upload/ExcelUploader.css";

const ExcelUploader = () => {
  const [file, setFile] = useState(null);
  const [jsonData, setJsonData] = useState(null); // Store JSON data

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      console.log("📂 File Selected:", selectedFile);
      setFile(selectedFile);
      readExcelFile(selectedFile);
    } else {
      console.warn("⚠ No file selected!");
    }
  };

  const readExcelFile = (file) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);

    reader.onload = (event) => {
      const binaryData = event.target.result;
      const workbook = XLSX.read(binaryData, { type: "binary" });

      const sheetName = workbook.SheetNames[0]; // Get first sheet
      const sheet = workbook.Sheets[sheetName];

      const parsedData = XLSX.utils.sheet_to_json(sheet); // Convert to JSON

      console.log("📊 Parsed JSON Data Before Upload:", parsedData);
      setJsonData(parsedData); // Store JSON in state
    };

    reader.onerror = (error) => {
      console.error("❌ Error reading file:", error);
    };
  };

  const handleFileSubmit = async () => {
    if (!file) {
      alert("Please select a file!");
      console.warn("🚨 No file to upload!");
      return;
    }

    console.log("📤 Preparing to upload file:", file);
    console.log("📝 JSON Data to Upload:", jsonData); // Log JSON data before upload

    const formData = new FormData();
    formData.append("file", file);
    formData.append("jsonData", JSON.stringify(jsonData)); // Send JSON with the file

    for (let [key, value] of formData.entries()) {
      console.log(`📝 FormData Entry - ${key}:`, value);
    }

    try {
      const response = await axios.post("http://localhost:5000/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log("✅ Upload Successful:", response.data);
      console.log("📄 JSON Response After Upload:", JSON.stringify(response.data, null, 2));

      alert(response.data.message);
    } catch (error) {
      console.error("❌ Error uploading file:", error);
      if (error.response) {
        console.error("🛑 Server Response:", JSON.stringify(error.response.data, null, 2));
      }
      alert("Upload failed. Please try again.");
    }
  };

  return (
    <div className="container-up">
      <div className="div-uploader">
        <h2 className="title-up">Upload Flight Excel File</h2>
        <input
          className="input-up"
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileUpload}
        />
        <button className="button-up" onClick={handleFileSubmit}>
          Upload
        </button>
        <img src="logo2.png" className="logo-login" alt="logo" />
      </div>
    </div>
  );
};

export default ExcelUploader;
